export const REPLAY_CONSENT_VERSION = '1'

const REPLAY_CONSENT_STORAGE_KEY = 'sensei.replay-consent'

type StoredReplayConsent = {
  version: string
  granted: boolean
}

export function readReplayConsent(): boolean {
  try {
    const rawValue = window.localStorage.getItem(REPLAY_CONSENT_STORAGE_KEY)
    if (!rawValue) {
      return false
    }

    const storedValue = JSON.parse(rawValue) as Partial<StoredReplayConsent>
    return (
      storedValue.version === REPLAY_CONSENT_VERSION &&
      storedValue.granted === true
    )
  } catch {
    return false
  }
}

export function writeReplayConsent(granted: boolean): void {
  try {
    const storedValue: StoredReplayConsent = {
      version: REPLAY_CONSENT_VERSION,
      granted,
    }
    window.localStorage.setItem(
      REPLAY_CONSENT_STORAGE_KEY,
      JSON.stringify(storedValue),
    )
  } catch {
    // Storage unavailable: consent remains fail-closed for future initializations.
  }
}
